import './index.styl'
import Menu from './menu'
import React from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import SegmentRow from './segment-row'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  componentWillMount () {
    const { type, project, actions, segment } = this.props

    if (type === null) {
      actions.push('/')
      return
    }

    if (project === null) {
      actions.push('/')
      return
    }

    if (type !== 'segments') {
      actions.push('/headers')
      return
    }
  }

  setSegment (segment) {
    const { actions } = this.props

    actions.setSegment(segment.id)
    actions.push('/headers')
  }

  render () {
    const { segments, fetched, fetching, actions, auth, project, segment } = this.props
    const rows = []

    if (fetched === false && fetching === false) {
      // Fetch the list of types...
      actions.fetchSegments(auth.token, project)

      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Momentje...</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && segments.length === 0) {
      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Geen segmenten gevonden</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && segments.length > 0) {
      segments.forEach((s, index) => {
        rows.push(<SegmentRow segment={s} key={index} active={s.id === segment} click={(e) => { this.setSegment(s) }} />)
      })
    }

    return (
      <main>
        <section className="container">
          <Row>
            <Col xs={12}>
              {rows}
            </Col>
          </Row>
        </section>
      </main>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Segments/index.js